
import CloseIcon from "@mui/icons-material/Close";
import {
    Avatar,
    Box,
    Button, Dialog, Divider, Drawer, Grid,
    Hidden, IconButton,
    Typography
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment-timezone";
import React from "react";
import { DialogDrawer, SlideButton, TextBox } from '../../components';
import { config } from "../../config";
import { AlertContext } from "../../contexts";
import { COLLECTED_AMOUNT } from "../../graphql/mutations";
import { NetworkCall } from "../../networkcall";
import ViewDetails from "../../screens/gateEntry/viewDetails";
import { AlertProps, Bold, currencyFormater, ExtraBold, generateImageUrl, img_size, LocalStorageKeys, NetWorkCallMethods, Regular, SemiBold, visitorTypes } from "../../utils";
// import ImageViewer from "react-simple-image-viewer";
import { withNamespaces } from "react-i18next";

const useStyles = makeStyles((theme) => ({

    rootCard: {
        backgroundColor: "white",
        borderRadius: "16px",
        boxShadow: "0px 3px 16px #00000014",
        border: "1px solid #E4E8EE"
    },
    img: {
        // borderRadius: "8px",
        // border: "1px solid #E4E8EE",
        // padding: "2px 8px",
    },

    title: {
        fontSize: "1rem",
        fontFamily: Bold,
        color: "#4E5A6B",
    },
    title2: {
        fontSize: "0.875rem",
        fontFamily: SemiBold,
        color: theme.typography.color.primary,
    },
    sub: {
        fontSize: "0.75rem",
        color: theme.palette.primary.main,
        cursor: "pointer",
        fontFamily: Regular
    },

    border: {
        borderBottom: "2px solid #E4E8EE",
    },
    heading: {
        fontSize: "0.75rem",
        color: theme.typography.color.Tertiary,
        fontFamily: SemiBold,
        marginTop: "10px",
    },
    heading2: {
        fontSize: "0.875rem",
        color: theme.typography.color.Tertiary,
        fontFamily: SemiBold,
    },
    heading3: {
        fontSize: "0.875rem",
        color: theme.palette.success.main,
        fontFamily: SemiBold,
    },
    name: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        fontFamily: SemiBold,
    },
    span: {
        backgroundColor: "#5078E11E",
        color: "#98A0AC",
        fontSize: "0.75rem",
        fontFamily: Bold,
        marginLeft: "6px",
        padding: "4px",
        borderRadius: "4px"

    },
    drawer: {
        "& .MuiDrawer-paper": {
            borderTopRightRadius: "16px",
            borderTopLeftRadius: "16px",
        },
        "& .MuiContainer-root": {
            padding: "0px 8px",
        },
    },
    dialog: {
        "& .MuiDialog-paper": {
            borderRadius: "16px",
            padding: "0px",
        },
    },
    titleroot: {
        borderBottom: "1px solid #c1c1c1",
        padding: "8px",
    },
    bottomBarTitle: {
        fontSize: "1.125rem",
        fontFamily: ExtraBold,
        color: theme.typography.color.primary,
    },
    iconButtonStyle: {
        height: "44px",

        padding: "12px 16px 12px 16px",
        borderRadius: "8px",
        color: "#5078E1",
        background: "#5078E1",
        backgroundColor: "#5078E1",
        boxShadow: "0px 2px 6px #00000021",
    },
    saveNUpdateButtonTextStyle: {
        fontSize: "0.875rem",
        color: "#FFFFFF",
        fontWeight: "bold",
        fontFamily: Bold
    },
    saveNUpdateButtonContainerStyle: {
        padding: "16px",
        background: "white",
        border: "1px solid #E4E8EE",
        boxShadow: "0px -7px 20px #0717410D",
        // position: "fixed",
        width: "-webkit-fill-available",
    },
    sucess: {
        backgroundColor: theme.palette.success.main,
        "&:hover": {
            backgroundColor: theme.palette.success.main,
        }
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        // padding: 2,
        "&:hover": {
            backgroundColor: theme.palette.warning.main,
        }
    },

}));

const DetailsCard = (props) => {
    const { t = () => false } = props
    const classes = useStyles(props);
    const [drawer, setDrawer] = React.useState(false);
    const [drawerAmount, setDrawerAmount] = React.useState(false);
    const [showBill, setShowBill] = React.useState(props?.data?.is_unit_bill);
    const [amount, setAmount] = React.useState([])
    const alert = React.useContext(AlertContext);
    const [details, setDetails] = React.useState({})
    const [collectedAmount, setCollectedAmount] = React.useState("")
    const [swiftId, setSwiftId] = React.useState("")
    const userProfileId = localStorage.getItem(LocalStorageKeys.userId)
    const clientId = JSON.parse(localStorage.getItem(LocalStorageKeys.client))?.id;
    const openDrawer = (val) => {

        setDetails(val)
        props?.ReloadEnum()
        setDrawer(true)
    }
    const openDrawerAmount = () => {
        setDrawerAmount(true)
    }

    const ChargesApi = () => {
        const data = {
            tenantId: `${config.tenantid}`,
            request_id: props?.data?.id
        };
        NetworkCall(
            `${config.api_url}/security/charges`,
            NetWorkCallMethods.post,
            data,
            null,
            true,
            false
        )
            .then((response) => {
                if (response.status === 200) {
                    setAmount(response?.data?.data[0])
                    props?.Reload()
                }
            })
            .catch((error) => {
                console.log(error);
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Something Went Wrong"),
                });
            });

    }

    React.useEffect(() => {
        if (props?.data?.actual_out) {
            ChargesApi()
        }
        // eslint-disable-next-line
    }, [props?.data?.actual_out])

    const CollectedAmountApi = () => {
        if (collectedAmount !== "") {
            const payload = {
                query: COLLECTED_AMOUNT,
                variables: {
                    data: {
                        actual_payment: parseFloat(collectedAmount),
                        balance: parseFloat(amount?.payment_charges - collectedAmount).toFixed(1),
                        payment_status: 'Collected'
                    },
                    request_id: props?.data?.id
                }
            }
            NetworkCall(
                `${config.graphql_url}`,
                NetWorkCallMethods.post,
                payload,
                null,
                true,
                false
            )
                .then((response) => {
                    alert.setSnack({
                        ...alert,
                        open: true,
                        severity: AlertProps.severity.success,
                        msg: t("Amount collected successfully"),
                    });
                    setDrawerAmount(false)
                    props?.Reload()
                })
                .catch((err) => {
                    console.log(err);
                    alert.setSnack({
                        ...alert,
                        open: true,
                        severity: AlertProps.severity.error,
                        msg: t("Something Went Wrong"),
                    });
                });
        }
    }
    const BillToAmountApi = () => {
        const payload = {
            query: COLLECTED_AMOUNT,
            variables: {
                data: {
                    payment_status: 'Pending',
                    is_unit_bill: true
                },
                request_id: props?.data?.id
            }
        }
        NetworkCall(
            `${config.graphql_url}`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false
        )
            .then((response) => {
                setShowBill(true)
                props?.Reload()
            })
            .catch((err) => {
                console.log(err);
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Something Went Wrong"),
                });
            });
    }


    //domestic checkin out

    const checkIn = () => {
        let currentDate = new Date().toISOString()
        const payload = {
            access_gate_id: Number(props?.gateId),
            check_in_by: userProfileId,
            check_in_time: currentDate,
            created_at: currentDate,
            created_by: userProfileId,
            helper_id: props?.data?.domestic_helper_units?.[0]?.helper?.id,
            is_active: true,
            person_name: props?.data?.domestic_helper_units?.[0]?.helper?.name,
            property_id: props?.propertyId,
            visitor_type: visitorTypes?.domesticHelper,
            client: clientId,
            event: "Check-In"
        }
        NetworkCall(
            `${config.api_url}/security/upsert_swift_in_out_logs`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false
        )
            .then((response) => {
                if (response?.data?.data) {
                    setSwiftId(response?.data?.data?.swift_in_out_log[0]?.id)
                    alert.setSnack({
                        ...alert,
                        open: true,
                        severity: AlertProps.severity.success,
                        msg: t("checked In"),
                    });
                    props?.Reload()
                }
            })
            .catch((err) => {
                console.log(err);
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Something Went Wrong"),
                });
            });
    }

    const checkOut = () => {
        let currentDate = new Date().toISOString()
        const payload = {
            id: props?.data?.swift_in_out_log?.[0]?.id ? props?.data?.swift_in_out_log?.[0]?.id : swiftId,
            check_out_by: userProfileId,
            check_out_time: currentDate,
            updated_by: userProfileId,
            updated_at: currentDate,
            client: clientId,
            access_gate_id: Number(props?.gateId),
            event: "Check-Out"
        }
        NetworkCall(
            `${config.api_url}/security/upsert_swift_in_out_logs`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false
        )
            .then((response) => {
                props?.domesticCheckout(response?.data?.data?.swift_in_out_log?.[0]?.id)
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.warning,
                    msg: t("checked Out"),
                });
                props?.Reload()
            })
            .catch((err) => {
                console.log(err);
                alert.setSnack({
                    ...alert,
                    open: true,
                    severity: AlertProps.severity.error,
                    msg: t("Something Went Wrong"),
                });
            });
    }

    const timeStringStart = props?.parentData?.work_hour_start; // example time string in HH:MM:SS format
    const timeStringEnd = props?.parentData?.work_hour_end; // example time string in HH:MM:SS format

    const timePartsStart = timeStringStart?.split(":"); // split the string into an array of parts
    const timePartsEnd = timeStringEnd?.split(":"); // split the string into an array of parts

    const workStartHours = parseInt(timePartsStart?.[0], 10); // get the hours as an integer
    const workStartMinutes = parseInt(timePartsStart?.[1], 10); // get the minutes as an integer
    // const workStartSeconds = parseInt(timePartsStart[2], 10);

    const workEndHours = parseInt(timePartsEnd?.[0], 10); // get the hours as an integer
    const workEndMinutes = parseInt(timePartsEnd?.[1], 10); // get the minutes as an integer
    // const workEndSeconds = parseInt(timePartsEnd[2], 10);

    let now = new Date();

    // Create a new Date object for the given time
    let givenStartTime = new Date();
    givenStartTime.setHours(workStartHours); // Set the hours to 10 (for example)
    givenStartTime.setMinutes(workStartMinutes); // Set the minute
    // Create a new Date object for the given time
    let givenEndTime = new Date();
    givenEndTime.setHours(workEndHours); // Set the hours to 10 (for example)
    givenEndTime.setMinutes(workEndMinutes); // Set the minute
    const workerDisableButton = ((now.getTime() < givenStartTime.getTime()) || now.getTime() > givenEndTime.getTime()) ? true : false
    const disableButton = ((new Date() <= new Date(props?.parentData?.request_from)) || (new Date() >= new Date(props?.parentData?.request_to))) ? true : false
    const disabled = props?.type === "WGR" ? (disableButton ? disableButton : ((props?.data?.check_in_time !== null && props?.data?.check_out_time !== null) || props?.data?.check_in_time === null) && workerDisableButton) : (disableButton || (props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single"))
    return (
        <>
            <div className={classes.rootCard}>
                {props?.data?.domestic_helper_units &&
                    <>
                        <Box p={"12px"}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("APPROVED UNITS AS DOMESTIC HELPER")}
                                    </Typography>
                                    <Typography variant="subtitle2" className={classes.title2}>
                                        {props?.data?.domestic_helper_units.map((item) => item?.unit?.name).join(',')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} margin={"10px 0px"}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("Checked in")}
                                    </Typography>
                                    {props?.data?.swift_in_out_log &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.swift_in_out_log?.[0]?.check_in_time &&
                                                <>
                                                    {props?.data?.swift_in_out_log?.[0]?.check_in_by?.first_name && "By " + props?.data?.swift_in_out_log?.[0]?.check_in_by?.first_name + ","}&nbsp;
                                                    {props?.data?.swift_in_out_log?.[0]?.check_in_time ? moment(props?.data?.swift_in_out_log?.[0]?.check_in_time).tz(moment.tz.guess())
                                                        .format("DD MMM YY  hh:mm:a") : "-"}
                                                </>
                                            }
                                        </Typography>

                                    }

                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("Checked out")}
                                    </Typography>
                                    {props?.data?.swift_in_out_log &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.swift_in_out_log?.[0]?.check_in_time &&
                                                <>
                                                    {props?.data?.swift_in_out_log?.[0]?.check_out_by?.first_name && "By " + props?.data?.swift_in_out_log?.[0]?.check_out_by?.first_name + ","}&nbsp;
                                                    {props?.data?.swift_in_out_log?.[0]?.check_out_time ? moment(props?.data?.swift_in_out_log?.[0]?.check_out_time).tz(moment.tz.guess())
                                                        .format("DD MMM YY  hh:mm:a") : "-"}
                                                </>
                                            }
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <br />
                                    <SlideButton
                                        mainText={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? t("Swipe to Check In") : t("Swipe to Check Out")}
                                        overlayText={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? t("Checked In") : t("Checked Out")}
                                        classList={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? "my-class1" : "my-class2"}
                                        caretClassList={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? "my-caret-class1" : "my-caret-class2"}
                                        overlayClassList={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? "my-overlay-class1" : "my-overlay-class2"}
                                        onSlideDone={props?.data?.swift_in_out_log?.[0]?.check_in_time && props?.data?.swift_in_out_log?.[0]?.check_out_time ? checkIn : props?.data?.swift_in_out_log?.[0]?.check_in_time ? checkOut : checkIn}
                                        disabled={(moment(props?.data?.request_to).format("DD MMM HH:mm A") >= moment(new Date()).format("DD MMM HH:mm A")) === false ? true : false}
                                    />
                                    {/* <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={props?.data?.swift_in_out_log?.[0]?.check_in_time && props?.data?.swift_in_out_log?.[0]?.check_out_time ? checkIn : props?.data?.swift_in_out_log?.[0]?.check_in_time ? checkOut : checkIn}
                                        className={(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? classes.sucess : classes?.warning}
                                        // disabled={props?.data?.swift_in_out_log?.[0]?.check_in_time && props?.data?.swift_in_out_log?.[0]?.check_out_time}
                                        size="large"
                                    >
                                        {(props?.data?.swift_in_out_log?.[0]?.check_in_time === null || props?.data?.swift_in_out_log?.[0]?.check_out_time !== null) ? " Check In" : "Check Out"}
                                    </Button> */}
                                </Grid>
                            </Grid>
                        </Box>

                    </>
                }
                {!props?.data?.domestic_helper_units &&
                    <>
                        <Box display="flex" alignItems="center" p={"12px"} className={classes.border} >
                            <Box className={classes.img}>

                                {props?.type === "WGR" &&
                                    <>
                                        {(props?.data?.visitor_image || props?.data?.domestic_helpers?.visitor_image) ?
                                            <Avatar src={(props?.data?.visitor_image || props?.data?.domestic_helpers?.visitor_image) ? generateImageUrl((props?.data?.visitor_image || props?.data?.domestic_helpers?.visitor_image), img_size.small_square) : ""}
                                                onClick={() => props?.openImageViewer([(props?.data?.visitor_image || props?.data?.domestic_helpers?.visitor_image)])}
                                            >
                                            </Avatar> : <Avatar></Avatar>
                                        }
                                    </>
                                }

                                {props?.type === "VGR" &&
                                    <>
                                        {props?.data?.visitor_image ?
                                            <Avatar src={props?.data?.visitor_image ? generateImageUrl(props?.data?.visitor_image, img_size.small_square) : ""}
                                                onClick={() => props?.openImageViewer([props?.data?.visitor_image])}
                                            >
                                            </Avatar> : <Avatar></Avatar>
                                        }
                                    </>
                                }
                                {props?.type === "PSR" &&
                                    <>
                                        {props?.data?.vehicle_image ?
                                            <Avatar src={props?.data?.vehicle_image ? generateImageUrl(props?.data?.visitor_image, img_size.small_square) : ""}
                                                onClick={() => props?.openImageViewer([props?.data?.vehicle_image])}
                                            ></Avatar> :
                                            <Avatar></Avatar>
                                        }
                                    </>

                                }
                                {/* {props?.isViewerOpen && (
                                    <ImageViewer
                                        src={props?.currentImage}
                                        currentIndex={0}
                                        onClose={props?.closeImageViewer}
                                        disableScroll={false}
                                        backgroundStyle={{
                                            backgroundColor: "rgba(0,0,0,0.9)",
                                        }}
                                        closeOnClickOutside={true}
                                    />
                                )} */}
                            </Box>
                            <Box marginLeft={"12px"} >
                                <Typography variant="subtitle2" className={classes.name}>
                                    {(props?.data?.name || props?.data?.domestic_helpers?.name) ? (props?.data?.name || props?.data?.domestic_helpers?.name) : props?.data?.vechicle_number}
                                    {props?.data?.vechicle_type && <span className={classes.span}>{props?.data?.vechicle_type}</span>}
                                </Typography>
                                <Typography variant="subtitle2" className={classes.sub}>
                                    <div onClick={() => openDrawer(props?.data)}>
                                        {props?.data?.vechicle_type ? t("Update Details") : t("View Details")}
                                    </div>
                                </Typography>
                            </Box>
                        </Box>
                        <Box p={"12px"}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("Check in")}
                                    </Typography>
                                    {props?.data?.check_in_time &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.check_in_by && "By " + props?.data?.check_in_by + ","}&nbsp;
                                            {props?.data?.check_in_time ? moment(props?.data?.check_in_time).tz(moment.tz.guess())
                                                .format("DD MMM YY  hh:mm:a") : "-"}
                                        </Typography>
                                    }
                                    {props?.data?.actual_in &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.parking_check_in_by && "By " + props?.data?.parking_check_in_by + ","}&nbsp;
                                            {props?.data?.actual_in ? moment(props?.data?.actual_in).tz(moment.tz.guess())
                                                .format("DD MMM YY  hh:mm:a") : "-"}
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("Check out")}
                                    </Typography>
                                    {props?.data?.check_out_time &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.check_out_by && "By " + props?.data?.check_out_by + ","}&nbsp;
                                            {props?.data?.check_out_time ? moment(props?.data?.check_out_time).tz(moment.tz.guess())
                                                .format("DD MMM YY  hh:mm:a") : "-"}
                                        </Typography>
                                    }
                                    {props?.data?.actual_out &&
                                        <Typography variant="subtitle2" className={classes.title}>
                                            {props?.data?.parking_check_out_by && "By " + props?.data?.parking_check_out_by + ","}&nbsp;
                                            {props?.data?.actual_out ? moment(props?.data?.actual_out).tz(moment.tz.guess())
                                                .format("DD MMM YY  hh:mm:a") : "-"}
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <br />
                                    {props?.data?.vechicle_type ?
                                        <SlideButton
                                            mainText={props?.data?.actual_in === null && props?.data?.actual_out === null ? t("Swipe to Check In") : t("Swipe to Check Out")}
                                            overlayText={props?.data?.actual_in === null && props?.data?.actual_out === null ? t("Checked In") : t("Checked Out")}
                                            classList={props?.data?.actual_in === null && props?.data?.actual_out === null ? "my-class1" : "my-class2"}
                                            caretClassList={props?.data?.actual_in === null && props?.data?.actual_out === null ? "my-caret-class1" : "my-caret-class2"}
                                            overlayClassList={props?.data?.actual_in === null && props?.data?.actual_out === null ? "my-overlay-class1" : "my-overlay-class2"}
                                            onSlideDone={() => openDrawer(props?.data)}
                                            disabled={(moment(props?.data?.request_to).format("DD MMM HH:mm A") >= moment(new Date()).format("DD MMM HH:mm A")) === false ? true : props?.data?.actual_in && props?.data?.actual_out}
                                        />
                                        // <Button
                                        //     fullWidth
                                        //     variant="contained"
                                        //     onClick={() => openDrawer(props?.data)}
                                        //     color={props?.data?.actual_in === null && props?.data?.actual_out === null ? "success" : "warning"}
                                        //     disabled={props?.data?.actual_in && props?.data?.actual_out}
                                        //     size="large"
                                        // >
                                        //     {props?.data?.actual_in === null && props?.data?.actual_out === null ? " Check In" : "Check Out"}
                                        // </Button>
                                        :
                                        <SlideButton
                                            mainText={(props?.data?.check_in_time === null || props?.data?.check_out_time !== null) ? t("Swipe to Check In") : t("Swipe to Check Out")}
                                            overlayText={(props?.data?.check_in_time === null || props?.data?.check_out_time !== null) ? t("Checked In") : t("Checked Out")}
                                            classList={(props?.data?.check_in_time === null || props?.data?.check_out_time !== null) ? "my-class1" : "my-class2"}
                                            caretClassList={(props?.data?.check_in_time === null || props?.data?.check_out_time !== null) ? "my-caret-class1" : "my-caret-class2"}
                                            overlayClassList={(props?.data?.check_in_time === null || props?.data?.check_out_time !== null) ? "my-overlay-class1" : "my-overlay-class2"}
                                            onSlideDone={() => openDrawer(props?.data)}
                                            disabled={(moment(props?.data?.request_to).format("DD MMM HH:mm A") >= moment(new Date()).format("DD MMM HH:mm A")) === false ? true : (props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single") || disabled}
                                        // disabled={disableButton || (props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single")}
                                        />

                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </>}
            </div >
            {props?.data?.actual_out &&
                <>
                    <br />
                    <div className={classes.rootCard}>
                        <Box p={"12px"}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("ALLOCATED PARKING TIME")}
                                    </Typography>
                                    <Typography variant="subtitle2" className={classes.title}>
                                        {props?.data?.approved_hours ? props?.data?.approved_hours + `${" Hrs"}` : " - "}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" className={classes.heading}>
                                        {t("ACTUAL PARKING TIME")}
                                    </Typography>
                                    <Typography variant="subtitle2" className={classes.title}>
                                        {props?.data?.actual_hours ? props?.data?.actual_hours + `${" Hrs"}` : " 0 "}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} margin="10px 0px">
                                    <Divider />
                                </Grid>
                                <Grid item xs={6} marginBottom="5px">
                                    <Typography variant="subtitle2" className={classes.heading2}>
                                        {t("Chargers to be collected")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} textAlign="right" marginBottom="5px">
                                    {amount?.code &&
                                        <Typography variant="subtitle2" className={classes.title2}>
                                            {amount?.symbol}&nbsp;{amount?.payment_charges ? currencyFormater(amount?.payment_charges) : " - "}
                                        </Typography>
                                    }
                                </Grid>
                                {showBill &&
                                    <>
                                        <Grid item xs={6} marginBottom="5px">
                                            <Typography variant="subtitle2" className={classes.heading3}>
                                                {t("Bill to the unit")}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} textAlign="right" marginBottom="5px">
                                            {amount?.code &&
                                                <Typography variant="subtitle2" className={classes.heading3}>
                                                    {amount?.symbol}&nbsp;{amount?.payment_charges ? currencyFormater(amount?.payment_charges) : " - "}
                                                </Typography>
                                            }
                                        </Grid>
                                    </>
                                }

                                <Grid item xs={5.5} >
                                    <Button variant="outlined"
                                        fullWidth
                                        // padding="0px 8px"
                                        style={{ borderRadius: "8px" }}
                                        onClick={BillToAmountApi}
                                        disabled={showBill ? showBill : props?.data?.actual_payment}
                                    >
                                        {t("Bill To The Unit")}
                                    </Button>
                                </Grid>
                                <Grid item xs={1} />
                                <Grid item xs={5.5}>
                                    <Button variant="contained"
                                        fullWidth
                                        style={{ borderRadius: "8px", padding: "6px 12px" }}
                                        onClick={openDrawerAmount}
                                        disabled={showBill ? showBill : props?.data?.actual_payment}
                                    >
                                        {t("Collected amount")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                        <Hidden smDown>
                            <Dialog
                                className={classes.dialog}
                                maxWidth="sm"
                                fullWidth
                                open={drawerAmount}
                                onClose={() => setDrawerAmount(false)}
                            >
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            className={classes.titleroot}
                                        >
                                            <Box flexGrow={1}>
                                                <Typography
                                                    variant="subtitle2"
                                                    className={classes.bottomBarTitle}
                                                >
                                                    {t("Collect Amount")}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <IconButton size="small" onClick={() => setDrawerAmount(false)}>
                                                    <CloseIcon color="secondary" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} p={2} margin={"6px"}>
                                        <TextBox label={t("Collected Amount")} value={collectedAmount} onChange={(e) => setCollectedAmount(e.target.value)} />
                                    </Grid>
                                    <Grid xs={12} className={classes.saveNUpdateButtonContainerStyle}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            className={classes.iconButtonStyle}
                                            onClick={CollectedAmountApi}
                                        >
                                            <Typography className={classes.saveNUpdateButtonTextStyle}>
                                                {t("Collect And Close")}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Dialog>
                        </Hidden>
                        <Hidden smUp>
                            <Drawer
                                className={classes.drawer}
                                anchor="bottom"
                                open={drawerAmount}
                                onClose={() => setDrawerAmount(false)}
                            >
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            className={classes.titleroot}
                                        >
                                            <Box flexGrow={1}>
                                                <Typography
                                                    variant="subtitle2"
                                                    className={classes.bottomBarTitle}
                                                >
                                                    {t("Collect Amount")}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <IconButton size="small" onClick={() => setDrawerAmount(false)}>
                                                    <CloseIcon color="secondary" />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} p={2} margin={"6px"}>
                                        <TextBox label={t("Collected Amount")} value={collectedAmount} onChange={(e) => setCollectedAmount(e.target.value)} />
                                    </Grid>
                                    <Grid xs={12} className={classes.saveNUpdateButtonContainerStyle}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            className={classes.iconButtonStyle}
                                            onClick={CollectedAmountApi}
                                        >
                                            <Typography className={classes.saveNUpdateButtonTextStyle}>
                                                {t("Collect And Close")}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </Grid>

                            </Drawer>
                        </Hidden>
                    </div>
                </>
            }
            <DialogDrawer
                open={props?.isViewerOpen}
                onClose={props?.closeImageViewer}
                header={"View"}
                component={
                    <div>
                        <img src={props?.currentImage} alt="" style={{ width: "100%", height: "450px" }} />
                    </div>
                }
            />

            {/* drawer */}
            <Hidden smDown>
                <Dialog
                    className={classes.dialog}
                    maxWidth="sm"
                    fullWidth
                    open={drawer}
                    onClose={() => setDrawer(false)}
                >
                    <ViewDetails
                        t={t}
                        onClose={() => setDrawer(false)}
                        data={details}
                        gateId={Number(props?.gateId)}
                        requestId={props?.parentDataId}
                        type={props?.type}
                        Reload={props?.Reload}
                        proofData={props?.proofData}
                        statusKey={props?.statusKey}
                        disabled={(props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single") || disabled}

                    // disabled={disableButton || (props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single")}
                    />
                </Dialog>
            </Hidden>
            <Hidden smUp>
                <Drawer
                    className={classes.drawer}
                    anchor="bottom"
                    open={drawer}
                    onClose={() => setDrawer(false)}
                >
                    <ViewDetails
                        onClose={() => setDrawer(false)}
                        data={details}
                        type={props?.type}
                        Reload={props?.Reload}
                        requestId={props?.parentDataId}
                        proofData={props?.proofData}
                        statusKey={props?.statusKey}
                        gateId={Number(props?.gateId)}
                        disabled={(props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single") || disabled}
                    // disabled={disableButton || (props?.data?.check_in_time !== null && props?.data?.check_out_time !== null && props?.parentData?.entry_type === "single")}
                    />
                </Drawer>
            </Hidden>
        </>
    )
}
export default withNamespaces("detailsCard")(DetailsCard)
